<template>
  <div id="secondnav">
    <ul class="nav_box mainWidth">
      <li class="nav_item" v-for="(item,idx) in $t(nav+'.secondnav')">
        <nav v-if="item.index!=null" @click="propIdx(item.index)" :class="nowNav==idx?'router-link-active':''">
          <div class="nav_icon"><img :src="nowNav==idx?item.activeIcon:item.icon" alt=""></div>
          <span class="nav_title">{{item.title}}</span>
        </nav>
        <router-link v-else :to="{name:item.name}" tag="nav">
          <div class="nav_icon"><img :src="item.name==$route.path.split('/')[2]?item.activeIcon:item.icon" alt=""></div>
          <span class="nav_title">{{item.title}}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'secondnav',
  data () {
    return {
      nowNav:0,
    }
  },
  mounted(){
    this.$route.query.idx?this.propIdx(this.$route.query.idx):'';
    window.addEventListener('scroll', this.listenScroll)
  },
  methods:{
    propIdx(idx){ //emit
      this.nowNav=idx;
      this.$emit('changetable',idx);
    },
    listenScroll(){
      //是否有吸顶菜单
      var oDiv = document.getElementById('secondnav');
      var nextT = document.getElementById("secNavNextBox") && document.getElementById("secNavNextBox").getBoundingClientRect().top
      if (oDiv && nextT!=null) {

        var divHeight = document.getElementById("secondnav").offsetHeight ||210;
        var nextT = document.getElementById("secNavNextBox").getBoundingClientRect().top
        //vue获取body scrollTop始终为0,改用监控secNavNextBox来实现
        if (nextT <= divHeight) {
          oDiv.className = "navFixed";
        } else {
          oDiv.className = "";
        }

      }
    }
  },
  props:['nav'],
}
</script>

<style lang="less">
#secondnav{
   background: #FFFFFF;
   box-shadow: 0 4px 4px 0 rgba(0,0,0,0.04);
   height:80px;
  min-height:36px;
  margin-bottom:3px;
  clear:both;
  .nav_box{
    height:inherit;
    .nav_item{
      height:inherit;
      margin:0px 26px;
      float:left;
      >nav{
        width:inherit;
        /*padding:16px 12px;*/
        height:inherit;
        cursor:pointer;

        .nav_icon{
          width:45px;
          height:45px;
          margin:0 auto;
          img{
            width:inherit;
            height:inherit;
          }
        }
        .nav_title{
          font-size: 14px;
          color: #9196AC;;
          letter-spacing: 0;
          padding:6px 0px;
          line-height: 36px;
          transition:all 500ms;
        }
      }
      .router-link-active{
        border-bottom:3px solid #6FA0FF;
        .nav_title{
          /*font-weight:600;*/
          color:#2095D4;
        }
      }
    }
  }

}
</style>
<style lang="less">
  .mu-tabs{
    background-color:RGBA(0,0,0,0);
    .mu-tab-text{
      transition:all 500ms;
    }
    .mu-tab-active{
      background:rgba(0,0,0,0.3);
      .mu-tab-text{
        color:#fff;
        font-size:16px;
      }
    }
  }
  .line{
    background-color:RGBA(255,255,255,0.3);
    border-top:4px solid #2095D4;
    top:0;
  }
  </style>



// WEBPACK FOOTER //
// src/components/secondnav.vue